import http from '../util/http'
//
const BASE_URI = '/api';

/**
 * /exam  接口
 */
// 登录
export function login(params){return http.post('basic/v2/userOuter/v2/login',params)}
export function modifyPwd(params){return http.postUrl('basic/user/modifyOldPasswd',params)}
// 外部用户权限菜单
export function getMenus(){return http.get(`/basic/usm/v2/getMenus`)}
// 文件上传地址
export const FILE_UPLOAD_URL = BASE_URI + '/zuul/basic/common/uploadV2?module=yljz';
export function getCurrentUserInfo(params){return http.get('/service-business-cm/system_common/getCurrentUserInfo',params,)}
//上传文件basic/common/uploadv2
export function uploadFile(params){return http.post('zuul/basic/common/uploadV2?module=yljz',params,'hasFile')}
// 获取文件信息
export function downFileApi(params){return http.post('basic/common/getFileListByIds',params  )}
// 获取文件信息
export function getFileListByIds(params){return http.post('/service-business-cm/system_common/getFileListByIds',params  )}

// 字典单个查询（全局）
export function getAYDictByTableCodeApi(params){return http.post(`/service-business-cm/cm_dictionary/getAYDictByTableCode`,params  )}
// 字典单个查询（医疗）
export function getCMDictByTableCodeApi(params){return http.post(`/service-business-cm/cm_dictionary/getCMDictByTableCode`,params  )}


/***************************** 医院首页统计 Start *************************/
// 获取账号医院信息
export function getAccountSystemInfo(params){return http.post(`/service-business-cm/system_common/getAccountSystemInfo`,params  )}

// 获取指定医院的救助汇总信息
export function getHospitalTotalInfo(){return http.post(`/service-business-cm/hospital_statistics/getHospitalTotalInfo`  )}
// 获取指定医院的年度救助汇总信息
export function getHospitalYearStatInfo(params){return http.get(`/service-business-cm/hospital_statistics/getHospitalYearStatInfo`,params   )}

// 获取指定医院的患儿和费用汇总信息
export function getHospitalChildAndOutlayStatInfo(){return http.post(`/service-business-cm/hospital_statistics/getHospitalChildAndOutlayStatInfo`  )}




/***************************** 医院首页统计 End *************************/





// 按条件查询患儿列表，后台分页
export function getDataListByCond(params){return http.post('/service-business-cm/help_request/getMyDataListByCond',params  )}
// 检查患儿是否存在
export function checkChildExistsApi(params){return http.post('/service-business-cm/help_request/checkChildExists',params  )}
// 按ID查询患儿详情
export function getHelpRequestDataById(params){return http.get('/service-business-cm/help_request/getDataById',params  )}
// 获取患儿附件信息
export function getRequestAttachInfo(params){return http.post('/service-business-cm/request_attach/getRequestAttachInfo',params  )}
// 获取患儿相关证明附件信息
export function getEvidenceAttachInfo(params){return http.post('/service-business-cm/evdence_attach/getEvidenceAttachInfo',params  )}
// 获取监护人附件信息
export function getGuardianAttachInfo(params){return http.post('/service-business-cm/family_attach/getGuardianAttachInfo',params  )}

// 获取指定患儿未合并的相似患儿列表
export function getNotMergedSimilarChildList(params){return http.get('/service-business-cm/similar_child/getNotMergedSimilarChildList',params  )}


// 获取监护人附件信息
export function getHospitalInfoDataById(params){return http.post('/service-business-cm/hospital_info/getDataById',params  )}
// 获取患儿相关证明附件信息集合
export function getEvidenceAttachInfoSet(params){return http.post('/service-business-cm/evdence_attach/getEvidenceAttachInfoSet',params  )}
// 获取患儿病例附件
export function getCaseAttachCaseAttachInfo(params){return http.post('/service-business-cm/case_attach/getCaseAttachInfo',params  )}
// 提交患儿审核
export function specialChildSubmitSpecialApi(params){return http.post(`/service-business-cm/special_child/submitSpecial`,params  )}
// 获取患儿病例信息
export function getChildCaseDataByHelpId(params){return http.get('/service-business-cm/child_case/getDataByHelpId',params  )}
// 按ID查询特殊患儿审核详情
export function getSpecialChildDataByIdApi(params){return http.get(`/service-business-cm/special_child/getDataById`,params  )}

// 保存患儿
export function save(params){return http.post('/service-business-cm/help_request/save',params  )}
// 删除患儿
export function deleteChild(params){return http.post('/service-business-cm/help_request/delete',params  )}
// 发送患儿注册验证码
export function sendCaptchaApi(params){return http.postUrl('/service-business-cm/help_request/sendCaptcha',params  )}
// 校验验证码是否匹配
export function isCaptchaMatchApi(params){return http.get('/service-business-cm/help_request/isCaptchaMatch',params  )}
// 获取医院管理伙伴列表
export function getMyHospitalListApi(params){return http.post('/service-business-cm/hospital_info/getMyHospitalList',params  )}
// 获取所有医院列表
export function getAllHospitalListApi(params){return http.post('/service-business-cm/hospital_info/getDataListByCondNoPaging',params  )}
// 获取所有医院列表
export function getMyHospitalListByCond(params){return http.post('/service-business-cm/hospital_info/getMyDataListByCond',params  )}
// 医院授权病种树状列表
export function getGrantedDiseasesTreeApi(params){return http.get('/service-business-cm/hospital_diseases/getGrantedDiseasesTree',params  )}
// 获取关联医院数据
export function getDataJoinById(params){return http.get('/service-business-cm/hospital_info/getDataJoinById',params  )}
// 获取所有病种树形列表，包含医院授权状态
export function getAllDiseasesTreeApi(params){return http.get('/service-business-cm/hospital_diseases/getAllDiseasesTree',params  )}
// 是否为公益宝贝
export function isWelfareBabyApi(params){return http.post('/service-business-cm/help_request/isWelfareBaby',params  )}
// 是否为字节对接
export function isZijieAutoApi(params){return http.get('/service-business-cm/help_request/isZijieAuto',params  )}
// 提交患儿注册
export function sbumitRequestApi(params){return http.post('/service-business-cm/help_request/sbumitRequest',params  )}
// 暂存患儿注册
export function saveRequestApi(params){return http.post('/service-business-cm/help_request/saveRequest',params  )}
// 重启已经关闭的家长账号
export function parentAccountReuse(params){return http.get('/service-business-cm/help_request/parentAccountReuse',params  )}
// 获取申请费用列表
export function getOutlayListByCondNoPaging(params){return http.post('/service-business-cm/help_stages/getMyOutlayListByCondNoPaging',params  )}

// 保存患儿基本信息
export function saveChildInfo(params){return http.get('/service-business-cm/child_base_info/save',params  )}
// 按救助编号查询患儿家庭情况
export function getFamilyDataByHelpId(params){return http.get('/service-business-cm/child_family/getDataByHelpId',params  )}
// 暂存医院代患儿注册
export function saveProxyRequest(params){return http.post('/service-business-cm/help_request/saveProxyRequest',params  )}
// 提交医院代患儿注册
export function sbumitProxyRequest(params){return http.post('/service-business-cm/help_request/sbumitProxyRequest',params  )}
// 按救助编号查询保险列表
export function getInsureDataByHelpId(params){return http.get('/service-business-cm/child_family/business_insure/getDataByHelpId',params  )}
// 按救助编号查询保险列表
export function getFamilyAttachInfo(params){return http.post('/service-business-cm/family_attach/getFamilyAttachInfo',params  )}


/*
* 患儿管理
* */
// 按救助申请ID获取患儿标签
export function getRequestLabels(params){return http.get('/service-business-cm/help_request/getRequestLabels',params  )}
// 按患儿ID获取患儿标签
export function getChildabels(params){return http.get('/service-business-cm/help_request/getChildabels',params  )}



// 按条件查询救助分期列表，后台分页（基金会端）
export function getHelpStagesApi(params){return http.post('/service-business-cm/help_stages/getDataListByCond',params  )}
// 按条件查询救助分期列表，不分页（基金会端）
export function getHelpStagesNoPageApi(params){return http.post('/service-business-cm/help_stages/getDataListByCondNoPaging',params  )}
// 获取患儿基本信息
export function getChildInfo(params){return http.get('/service-business-cm/child_base_info/getDataByHelpId',params  )}
// 保存电话核实信息
export function saveChildVerifyInfo(params){return http.post('/service-business-cm/help_request/saveChildVerifyInfo',params  )}

// 审核患儿
export function getChildApproveApi(params){return http.post('/service-business-cm/help_stages/childApprove',params  )}
// 按条件查询操作日志列表，不分页
export function getOperationDataListByCondNoPaging(params) { return http.post('/service-business-cm/operation_log/getDataListByCondNoPaging', params) }
// 获取特殊患儿申请记录，后台分页
export function getSpecialChildApi(params){return http.post(`/service-business-cm/special_child/getDataListByCond`,params  )}
// 下载图片
export function downLoadFileApi(params){return http.post(`/basic/common/getFileListByIds`,params  )}
// 按救助ID查询救助分期详情
export function getHelpStagesDataByIdApi(params){return http.get('/service-business-cm/help_stages/getDataById',params  )}
// 获取患儿病例附件信息
export function getCaseAttachInfo(params){return http.post('/service-business-cm/case_attach/getCaseAttachInfo',params  )}
//获取列表
export function getDataListByCondFq(params){return http.post('/service-business-cm/help_stages/getMyDataListByCond',params  )}
//获取列表不分页
export function getDataListByCondFqNoPaging(params){return http.post('/service-business-cm/help_stages/getMyDataListByCondNoPaging',params  )}
//获取列表不分页
export function getMyOutlayListByCond(params){return http.post('/service-business-cm/help_stages/getMyOutlayListByCond',params  )}

//按救助ID查询救助分期详情（包含救助总费用和救助医院列表）
export function getDataWithHospitalByIdFq(params){return http.get('/service-business-cm/help_stages/getDataWithHospitalById',params  )}
//按救助ID查询救助分期详情（包含救助总费用和救助医院列表）
export function getDataByIdFq(params){return http.get('/service-business-cm/help_stages/getDataById',params  )}
//医院为患儿新增病种
export function saveChildDiseasesFromManage(params){return http.post('/service-business-cm/help_request/saveChildDiseases',params  )}
//医院为患儿新增病种（代申请）help_request/saveProxyChildDiseases
export function saveChildDiseasesFromManageD(params){return http.post('/service-business-cm/help_request/saveProxyChildDiseases',params  )}
//新增分期
export function addNewStagesFq(params){return http.post('/service-business-cm/help_stages/addNewStages',params  )}
//按救助编号查询监护人列表
export function getParentsDataByHelpId(params){return http.get('/service-business-cm/child_family/guardian/getDataByHelpId',params  )}
//获取患儿审核记录，不分页
export function getJzshDataListByCondNoPaging(params){return http.post('/service-business-cm/child_appr_log/getDataListByCondNoPaging',params  )}
//按救助编号查询债务列表
export function getDataByHelpId(params){return http.get('/service-business-cm/child_family/debt/getDataByHelpId',params  )}
//按救助编号查询证明人列表
export function getcertifierDataByHelpId(params){return http.get('/service-business-cm/child_family/certifier/getDataByHelpId',params  )}
//按救助编号查询证明人列表
export function getOtherIncome(params){return http.get('/service-business-cm/child_family/other_income/getDataByHelpId',params  )}
//按救助编号查询家庭成员列表
export function getFamilyMemberByHelpId(params){return http.get('/service-business-cm/child_family/family_member/getDataByHelpId',params  )}
//按救助编号查询家庭成员列表
export function getMemberAttachInfo(params){return http.post('/service-business-cm/family_attach/getMemberAttachInfo',params  )}
// 注册转带申请
export function convertToHospitalProxy(params){ return http.get('/service-business-cm/help_request/convertToHospitalProxy', params ) }

/** *****************  费用相关 start  ********************* */
// 查询病例附件
export function getCaseAttachInfoSet(params) { return http.post('/service-business-cm/case_attach/getCaseAttachInfoSet', params) }
// 列表数据查询
export function getOutlayDataListByCond(params) { return http.post('/service-business-cm/outlay/getDataListByCond', params) }
// 费用单条记录查询
export function getOutlayDataById(id) { return http.get('/service-business-cm/outlay/getDataById?outlayId=' + id) }
// 根据费用id获取附件列表
export function getOutlayAttachByOutlayId(id) { return http.get('/service-business-cm/outlay/getAttachByOutlayId?outlayId=' + id) }
// 放弃费用
export function giveUpOutlay(params) { return http.post('/service-business-cm/outlay/giveUpOutlay', params) }
// 修改费用
export function modifyOutlay(params) { return http.post('/service-business-cm/outlay/modifyOutlay', params) }
// 治疗费用保存
export function saveCureOutlay(params) { return http.post('/service-business-cm/outlay/saveCureOutlay', params) }
// 治疗费用提交
export function submitCureOutlay(params) { return http.post('/service-business-cm/outlay/submitCureOutlay', params) }
// 检查费用保存
export function saveCheckOutlay(params) { return http.post('/service-business-cm/outlay/saveCheckOutlay', params) }
// 检查费用提交
export function submitCheckOutlay(params) { return http.post('/service-business-cm/outlay/submitCheckOutlay', params) }
// 根据费用id获取审批记录
export function getApprLogByOutlayId(params) { return http.get('/service-business-cm/outlay/getApprLogByOutlayId', params) }
// 保存新增费用与期次（天使）
export function saveNewOutlayAndStages(params) { return http.post('/service-business-cm/outlay/saveNewOutlayAndStages', params) }
// 提交新增费用与期次（天使）
export function submitNewOutlayAndStages(params) { return http.post('/service-business-cm/outlay/submitNewOutlayAndStages', params) }
// 根据救助id查询已申请救助金额
export function totalAngleOutlayAmount(params) { return http.post('/service-business-cm/outlay/totalAngleOutlayAmount', params) }
// 根据救助id查询剩余救助金额
export function getAngleRemainingAmount(params) { return http.post('/service-business-cm/outlay/getAngleRemainingAmount', params) }
// 根据救助id查询剩余救助金额
export function getAngleRemainingAmountByReqId(params) { return http.post('/service-business-cm/outlay/getAngleRemainingAmountByReqId', params) }
// 查询天使费用患儿列表
export function getAngleOutlayChild(params) { return http.post('/service-business-cm/outlay/getAngleOutlayChild', params) }

/** *****************  费用相关 end  ********************* */
/** *****************  病例相关 start  ********************* */
// 按救助编号查询患儿病例信息
export function getCaseDataByHelpId(params) { return http.get('/service-business-cm/child_case/getDataByHelpId', params) }
// 病例保存接口
export function childCaseSave(params) { return http.post('/service-business-cm/child_case/save', params) }
/** *****************  病例相关 end  ********************* */
/** *****************  协议相关 start  ********************* */
// 根据条件查询所有协议
export function getProtocolDataListByCond(params) { return http.post('/service-business-cm/protocol/info/getDataListByCond', params) }
// 下载协议
export function downloadProtocol(id) { return http.download('/service-business-cm/protocol/info/download?protocolId=' + id) }
//结算单下载
export function downloadProtocolJS(id) { return http.download('/service-business-cm/protocol/info/downloadJS?protocolId=' + id) }
// 下载退补款协议
export function downloadRefundProtocol(id, applyType) { return http.download('/service-business-cm/protocol/info/download?protocolId=' + id + '&applyType=' + applyType) }
// 按协议ID查询协议详情
export function getProtocolDataById(id) { return http.get('/service-business-cm/protocol/info/getDataById?protocolId=' + id) }
// 按协议ID查询协议详情
export function getSimpleDataById(id) { return http.get('/service-business-cm/protocol/info/getSimpleDataById?protocolId=' + id) }
// 根据协议id查询协议救助列表
export function selectDetailByProtocolId(id) { return http.get('/service-business-cm/protocol/detail/selectDetailByProtocolId?protocolId=' + id) }
// 提交退补款协议信息
export function submitRsProtocolInfo(params) { return http.post('/service-business-cm/protocol/info/submitRsProtocolInfo', params) }
// 协议审核
export function rsProtocolAudit(params) { return http.post('/service-business-cm/protocol/audit/rsProtocolAudit', params) }
// 获取付款银行列表
export function getPaymentBankList() { return http.get('/service-business-cm/protocol/info/getPaymentBankList') }
// 获取协议审核已办任务
export function getProtocolAuditDoneList(params) { return http.post('/service-business-cm/protocol/info/getProtocolAuditDoneList', params) }
// 获取协议审核代办任务
export function getProtocolAuditTodoList(params) { return http.post('/service-business-cm/protocol/info/getProtocolAuditTodoList', params) }
// 获取协议申请汇款已办任务
export function getProtocolRemitDoneList(params) { return http.post('/service-business-cm/protocol/info/getProtocolRemitDoneList', params) }
// 获取协议申请汇款代办任务
export function getProtocolRemitTodoList(params) { return http.post('/service-business-cm/protocol/info/getProtocolRemitTodoList', params) }
// 获取协议审核代办任务
export function getProtocolManageTodoList(params) { return http.post('/service-business-cm/protocol/info/getProtocolManageTodoList', params) }
// 按简单协议ID查询协议详情
export function getProtocolSimpleDataById(id) { return http.get('/service-business-cm/protocol/info/getSimpleDataById?protocolId=' + id) }
// 协议信息保存
export function modifyProtocolInfo(params) { return http.post('/service-business-cm/protocol/info/modifyProtocolInfo', params) }
// 协议审核
export function protocolAudit(params) { return http.post('/service-business-cm/protocol/audit/protocolAudit', params) }
// 费用退回
export function rollbackOutlay(params) { return http.post('/service-business-cm/protocol/audit/rollbackOutlay', params) }
// 个案退回
export function rollbackSingle(id) { return http.get('/service-business-cm/protocol/audit/rollbackSingle', id) }
// 协议审核记录
export function getProtocolLogListByCond(params) { return http.post('/service-business-cm/protocol/log/getDataListByCond', params) }
// 获取医院银行账号列表
export function getHospitalBankAccountList(params) { return http.post('/service-business-cm/hospital_bank/getDataListByCond', params) }
// 按申请ID查询协议详情
export function getDataByApplyId(id) { return http.get('/service-business-cm/protocol/info/getDataByApplyId?applyId=' + id) }
// 按申请ID查询协议详情
export function selectDetailByApplyId(id) { return http.get('/service-business-cm/protocol/detail/selectDetailByApplyId?applyId=' + id) }
// 按协议id查询关联协议信息
export function getProtocolListByRelationId(id, status) { return http.get('/service-business-cm/protocol/info/getProtocolListByRelationId?protocolId=' + id + '&publishStatus=' + status) }

// export function rollbackSingle(params) { return http.post('/service-business-cm/protocol/audit/rollbackSingle', params) }
/** *****************  协议相关 end  ********************* */

//费用excel导出
export function exportExcelOutlayList(data){return http.downloadPost('/service-business-cm/outlay/exportExcelOutlayList',data ,'post' )}

//费用excel导入
export const outlay_import_excel = BASE_URI + '/service-business-cm/outlay/outlayImportecxel'


// 校验住院号唯一
export function uniqueInHospitalNo(params) { return http.post('/service-business-cm/auto/valid/uniqueInHospitalNo', params) }

export function uniqueInHospitalSerialNo(params) { return http.post('/service-business-cm/auto/valid/uniqueInHospitalSerialNo', params) }

//检验病种是否重复
export function checkDiseasesRepeat(params){return http.post('/service-business-cm/help_request/checkDiseasesRepeat',params  )}

//添加相似患儿基础信息(注册)
export function addSimilarChildBaseInfo(params){return http.post('/service-business-cm/help_request/addSimilarChildBaseInfo',params  )}

//添加相似患儿基础信息(代申请)
export function addSimilarChildBaseInfoDai(params){return http.post('/service-business-cm/help_request/addSimilarChildBaseInfoDai',params  )}


//验证相似患儿基础信息
export function checkSimilarChildBaseInfo(params){return http.post('/service-business-cm/help_request/checkSimilarChildBaseInfo',params  )}





// WEBPACK FOOTER //
// ./src/util/api.js